import { useEffect, useRef, useState } from "react";

interface UseOverflowCheckProps {
  tolerance?: number;
}

interface UseOverflowCheckResult {
  containerRef: React.RefObject<HTMLUListElement>;
  isOverflowingLeft: boolean;
  isOverflowingRight: boolean;
}

const useOverflowCheck = ({
  tolerance = 0
}: UseOverflowCheckProps = {}): UseOverflowCheckResult => {
  const containerRef = useRef<HTMLUListElement>(null);
  const [isOverflowingLeft, setIsOverflowingLeft] = useState(false);
  const [isOverflowingRight, setIsOverflowingRight] = useState(false);

  useEffect(() => {
    const containerElement = containerRef.current;

    const handleOverflowCheck = () => {
      if (containerElement) {
        const isOverflowingToLeft = containerElement.scrollLeft > tolerance;
        const isOverflowingToRight =
          containerElement.scrollLeft +
            containerElement.clientWidth +
            tolerance <
          containerElement.scrollWidth;

        setIsOverflowingLeft(isOverflowingToLeft);
        setIsOverflowingRight(isOverflowingToRight);
      }
    };

    if (containerElement) {
      containerElement.addEventListener("scroll", handleOverflowCheck);
    }

    // Initial check when the component mounts
    handleOverflowCheck();

    return () => {
      if (containerElement) {
        containerElement.removeEventListener("scroll", handleOverflowCheck);
      }
    };
  }, [tolerance]);

  return { containerRef, isOverflowingLeft, isOverflowingRight };
};

export default useOverflowCheck;
